import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = ({ user, onLogout }) => {
  return (
    <nav className="navbar">
      <div className="navbar-content">
        <div className="navbar-brand">
          <Link to="/">Gestion Stock EPI - Admin</Link>
        </div>
        <ul className="navbar-links">
          <li><Link to="/">Tableau de bord</Link></li>
          <li><Link to="/stock">Gestion Stock</Link></li>
          <li><Link to="/requests">Demandes</Link></li>
          <li><Link to="/qrcode-general">QR Code</Link></li>
          <li><Link to="/users">Utilisateurs</Link></li>
          <li><Link to="/planif-sync">Sync Planif</Link></li>
        </ul>
        <div className="navbar-user" style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          {user && <span>{user.name}</span>}
          {onLogout && (
            <button
              onClick={onLogout}
              style={{
                background: 'rgba(255,255,255,0.15)',
                border: '1px solid rgba(255,255,255,0.3)',
                color: 'white',
                padding: '0.4rem 0.75rem',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '0.85rem'
              }}
            >
              Deconnexion
            </button>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
